<template>
  <div>
    <Card title="Home Section">
      <template v-slot:button>
        <Button variant="primary" label="Add Section" @clicked="add" />
      </template>
      <template v-slot:body>
        <el-table-draggable @sort="onSort"  handle=".handle-move" >
          <el-table :data="listSections" row-key="id" :show-header="true" style="width: 100%">
            <el-table-column label="" align="center" key="handle">
              <div class="static inline-block text-center container-action handle-move" style="cursor: move">
                <font-awesome-icon size="2x" :icon="['fa', 'th']" />
              </div>
            </el-table-column>
            <el-table-column v-for="column in tableColumn" :prop="column.prop" :label="column.label" :key="column.prop" sortable="custom">
            </el-table-column>
            <el-table-column label="Status" class="text-center" >
              <template slot-scope="scope">
                <label
                  :for="'toogle'+scope.row.id"
                  class="flex items-center"
                  :class="'cursor-pointer'"
                  style="height: 50px;"
                >
                  <!-- toggle -->
                  <div class="relative m-auto">
                    <!-- input -->
                    <input
                      :id="'toogle'+scope.row.id"
                      v-model="scope.row.publish"
                      @change="setStatusSection(scope.row)"
                      type="checkbox"
                      class="hidden"
                    />
                    <!-- line -->
                    <div
                      class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                    ></div>
                    <!-- dot -->
                    <div
                      class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                    ></div>
                  </div>
                  <!-- label -->
                </label>
              </template>
            </el-table-column>
            <el-table-column label="Actions" align="right">
              <template v-slot="scope">
                <div class="static inline-block text-left container-action">
                  <VueCustomTooltip label="Detail" :position="'is-left'">
                    <router-link :to="{ name: 'HomeSectionDetail', params: { sectionId: scope.row.id }}">
                      <a  class="p-2 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none" >
                        <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
                      </a>
                    </router-link>
                  </VueCustomTooltip>
                  <VueCustomTooltip label="Edit" :position="'is-left'">
                    <a @click="edit(scope.row)" class="p-2 mr-2 rounded bg-yellow-500 hover:bg-yellow-600 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
                    </a>
                  </VueCustomTooltip>
                  <VueCustomTooltip label="Delete" :position="'is-left'">
                    <button @click="deleteSection(scope.row)" class="p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                    </button>
                  </VueCustomTooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-table-draggable>
      </template>
    </Card>
    <ModalDialog
      ref="sectionForm"
      :isShowingModal="isShowingModal"
      :title="titleModal"
      @toggleModal="isShowingModal = !isShowingModal"
      :labelSubmit="'Submit'"
      @save="submitForm()" >
      <template slot="body" >
        <form class="flex w-full overflow-x-hidden" id="form-activity" autocomplete="off" >
          <div class="w-full p-2" >
            <form-item label="Title">
              <Input
                v-model="input.title"
                placeholder="ex. Album Name"
                :error="$v.input.title.$dirty && (!$v.input.title.required)"
              />
              <div class="flex flex-col pt-2">
                <text-error v-if="$v.input.title.$dirty && !$v.input.title.required" text="Please fill title." />
              </div>
            </form-item>
            <form-item v-if="!isEdit" label="Type">
              <select
                class="block border border-grey-light w-full p-3 rounded mb-4"
                name="genre"
                v-model="input.type"
              >
                <option :value="null"  >Select Type</option>
                <option value="artist">Artist</option>
                <option value="album">Album</option>
                <option value="song">Song</option>
                <option value="playlist">Playlist</option>
              </select>
              <div class="flex flex-col pt-2">
                <text-error v-if="$v.input.type.$dirty && !$v.input.type.required" text="Please fill type." />
              </div>
            </form-item>
          </div>
        </form>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import Vue from 'vue';
import ElTableDraggable from 'el-table-draggable';
import ModalDialogDetail from '@/components/Common/ModalDialogDetail';
import ModalDialog from '@/components/Common/ModalDialog';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import { mapActions, mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';
import { maxLength, required, email } from 'vuelidate/lib/validators';
import { Button, FormItem, Input, TextError } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';

export default {
  name: 'HomeSection',
  mixins: [validationMixin],
  data: () => ({
    listSections: [],
    isShowingModal: false,
    isEdit: false,
    input: {
      id: null,
      title: '',
      type: null,
      total_content: 0,
    },
    tableColumn: [
      {
        prop: 'title',
        label: 'Title',
      },
      {
        prop: 'type',
        label: 'Type',
      },

    ],
  }),
  computed: {
    ...mapGetters('NotificationModule', ['getErrorCode', 'getMessage', 'getStatus']),
    ...mapGetters('HomeSectionModule', ['listSection']),
    titleModal() {
      return this.isEdit ? 'Edit Section' : 'Add Section';
    },
  },
  validations() {
    const rules = {
      input: {
        title: { required },
      },
    };
    if (!this.isEdit) {
      rules.input.type = {
        required,
      };
    }
    return rules;
  },
  async mounted() {
    await this.requestListSection();
  },
  methods: {
    ...mapActions('HomeSectionModule', ['requestListSection', 'requestCreateSection',
      'requestReorderSection', 'requestDeleteSection', 'requestEditSection', 'requestPublishSection']),
    add() {
      this.isEdit = false;
      this.input = { ...this.input, id: null, title: '', type: null };
      this.resetForm();
      this.isShowingModal = true;
    },
    edit(row) {
      this.isEdit = true;
      this.input = { ...this.input, id: row.id, title: row.title, type: row.type };
      this.resetForm();
      this.isShowingModal = true;
    },
    resetForm() {
      this.$v.$reset();
    },
    async submitForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isShowingModal = !this.isShowingModal;
        const data = {
          title: this.input.title,
          total_content: this.input.total_content,
          type: this.input.type,
        };
        if (!this.isEdit) {
          await this.requestCreateSection(data);
        } else {
          await this.requestEditSection({ id: this.input.id, data });
        }
      }
    },
    async onSort(evt) {
      setTimeout(async () => {
        const ids = this.listSections.map(play => play.id);
        await this.requestReorderSection({
          id: ids,
        });
      }, 500);
    },
    async setStatusSection(section) {
      const status = {
        id: section.id,
        publish: section.publish,
      };
      await this.requestPublishSection(status);
    },
    async deleteSection(section) {
      Vue.swal({
        title: 'Delete Data!',
        text: `Are you sure to delete section: ${section.title}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestDeleteSection(section.id);
          this.$swal('Deleted', `You successfully delete section: ${section.title}`, 'success');
        }
      });
    },
  },
  watch: {
    listSection: {
      immediate: true,
      deep: true,
      async handler(val) {
        if (this.listSection) {
          this.listSections = this.listSection.map(s => ({ ...s, publish: (!!s.publish) }));
        }
      },
    },
  },
  components: {
    ElTableDraggable, VueCustomTooltip, ModalDialogDetail, ModalDialog,
    Button,
    Card,
    FormItem, Input, TextError
  },
};
</script>

<style scoped>
.toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #48bb78;
}
</style>



// WEBPACK FOOTER //
// src/views/AppSetting/HomeSection.vue